"use strict";

var _defineProperty = require("/home/circleci/project/story/node_modules/@babel/runtime/helpers/defineProperty");

var _taggedTemplateLiteral = require("/home/circleci/project/story/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = exports.InnerContainer = exports.ImgPortrait = exports.ImgLandscape = exports.Container = exports.BackgroundContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _typography = require("@titelmedia/bricks-theme/lib/utilities/typography");

var _layout = require("@titelmedia/bricks-theme/lib/utilities/layout");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Container = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 100vh;\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n"])));

exports.Container = Container;

var Title = _styledComponents.default.h1(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  line-height: 1em;\n  font-weight: normal;\n  margin: 0px;\n\n  ", "\n\n  color: ", ";\n  text-transform: ", ";\n\n  ", "\n\n  @media (min-width: 768px) {\n    max-width: 75vw;\n  }\n\n  @media (min-width: 1200px) {\n    max-width: 60vw;\n  }\n"])), function (props) {
  var fontProps = {};

  if (props.typeface === 'black') {
    fontProps.headline = true;
  } else if (props.typeface === 'deville') {
    fontProps.display = true;
  } else if (props.typeface === 'condensed') {
    fontProps.condensed = true;
  }

  return (0, _typography.setFont)(_objectSpread({}, fontProps));
}, function (props) {
  var _props$color;

  return ((_props$color = props.color) === null || _props$color === void 0 ? void 0 : _props$color.hex) || 'inherit';
}, function (props) {
  return props.typeface === 'black' || props.typeface === 'condensed' ? 'uppercase' : 'capitalize';
}, (0, _typography.setFontSizes)({
  mobile: '48px',
  tablet_vertical: '60px'
}));

exports.Title = Title;

var ImgPortrait = _styledComponents.default.img(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  @media (min-width: 992px) {\n    display: none;\n  }\n"])));

exports.ImgPortrait = ImgPortrait;

var ImgLandscape = _styledComponents.default.img(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  @media (min-width: 768px) {\n    max-width: 75vw;\n  }\n\n  @media (min-width: 1200px) {\n    max-width: 60vw;\n  }\n  @media (max-width: 991px) {\n    display: none;\n  }\n"])));

exports.ImgLandscape = ImgLandscape;

var InnerContainer = _styledComponents.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  padding-top: 32px;\n  padding-bottom: 32px;\n  box-sizing: border-box;\n\n  @media (min-width: 768px) {\n    padding-top: 48px;\n    padding-bottom: 48px;\n  }\n\n  @media (min-width: 1200px) {\n    padding-top: 64px;\n    padding-bottom: 64px;\n  }\n  ", "\n\n  ", "\n"])), function (props) {
  var verticalAlignment = props.verticalAlignment,
      horizontalAlignment = props.horizontalAlignment;
  var alignItems, justifyContent, textAlign;

  switch (verticalAlignment) {
    case 'top':
      alignItems = 'flex-start';
      break;

    case 'bottom':
      alignItems = 'flex-end';
      break;

    case 'center':
      alignItems = 'center';
      break;

    default:
      alignItems = 'center';
      break;
  }

  switch (horizontalAlignment) {
    case 'left':
      justifyContent = 'flex-start';
      textAlign = 'left';
      break;

    case 'right':
      justifyContent = 'flex-end';
      textAlign = 'right';
      break;

    case 'center':
      justifyContent = 'center';
      textAlign = 'center';
      break;

    default:
      justifyContent = 'center';
      textAlign = 'center';
      break;
  }

  return "\n        align-items: ".concat(alignItems, ";\n        justify-content: ").concat(justifyContent, ";\n        text-align: ").concat(textAlign, ";\n    ");
}, (0, _layout.setContainer)({
  size: 'xl'
}));

exports.InnerContainer = InnerContainer;

var BackgroundContainer = _styledComponents.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  background-image: url('", "');\n  background-size: cover;\n  background-position: center center;\n\n  iframe {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate3d(-50%, -50%, 0);\n  }\n\n  &:after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.35);\n  }\n"])), function (props) {
  var _props$backgroundImag;

  return (_props$backgroundImag = props.backgroundImage) === null || _props$backgroundImag === void 0 ? void 0 : _props$backgroundImag.src;
});

exports.BackgroundContainer = BackgroundContainer;